export function tryParseInt(val, fallbackValue) {
    const value = parseInt(val, 10);
    return isNaN(value) ? fallbackValue : value;
}
